import Image from "next/image";

import { Button, Container, Col, Row } from "react-bootstrap";
import LinkedinLogo from '../../assets/Illustrations/linkedin 2.svg'
import TwitterLogo from '../../assets/Illustrations/twitter 1.svg'
import WebsiteLogo from '../../assets/Illustrations/link.svg'
const WritersCard = (props) => {
    const {category} = props ;
  return (
    <div className="mt-3">
    <Row className="sm-justify-content-start lg-justify-content-center" >
        <Col sm={6} lg={12} xs={7} className="d-flex justify-content-start">
        <div >
            <img src={category.writersImageUrl} width="180px" height="170px" style={{borderRadius:"5px"}} />
              <h5 className=" mt-3 text-center" style={{fontWeight: "500", color: "#222222"}}>{category.writersName}</h5>
              <h5 className=" mt-3 text-center" style={{fontWeight: "400", color: "#888888",fontSize:"16px"}}>{category.writersJobRole}</h5>
              <div style={{display:"flex" ,justifyContent:"center"}}>
                <div   style={{
                                backgroundColor: "white",
                                borderRadius: "50%",
                                height: "25px",
                                width: "25px",
                                marginRight:"5px"
                              }}>
                                


                                {category.writersCompanyLogo != null && category.writersCompanyLogo != "null" ? (
                      <img
                        className=""
                        width="25"
                        height="25"
                        src={category.writersCompanyLogo}
                        alt=""
                        style={{
                          borderRadius: "50%",
                          marginLeft: "1px",                        
                        }}
                      />
                    ) : category.writersCompanyUrl.includes("ibm") &&
                      (category.writersCompanyLogo === null && category.writersCompanyLogo === "null")  ? (
                      <img
                        className=""
                        width="25"
                        height="25"
                        src="https://logo.clearbit.com/ibm.com"
                        alt=""
                        style={{
                          borderRadius: "50%",
                          marginLeft: "1px",                        
                        }}
                      />
                    ) : category.writersCompanyUrl.includes("google") &&
                      (category.writersCompanyLogo === null && category.writersCompanyLogo === "null") ? (
                      <img
                        className=""
                        width="25"
                        height="25"
                        src="https://logo.clearbit.com/google.com"
                        alt=""
                        style={{
                          borderRadius: "50%",
                          marginLeft: "1px",                        
                        }}
                      />
                    ) : category.writersCompanyUrl.includes("github") &&
                     (category.writersCompanyLogo === null && category.writersCompanyLogo === "null")  ? (
                      <img
                        className=""
                        width="25"
                        height="25"
                        src="https://logo.clearbit.com/github.com"
                        alt=""
                        style={{
                          borderRadius: "50%",
                          marginLeft: "1px",                        
                        }}
                      />
                    ) : (
                      <img
                        className=""
                        width="25"
                        height="25"
                        src={`https://logo.clearbit.com/google.com/${category.writersCompanyUrl}`}
                        alt=""
                        style={{
                          borderRadius: "50%",
                          marginLeft: "1px",                        
                        }}
                      />
                    )}   
                                    
                </div>
             
              <h5 className="m-1 text-center" style={{fontWeight: "400", color: "#888888",fontSize:"16px"}}>{category.writersCurrentCompany}</h5>
              </div>
              <div className="d-flex justify-content-center"> 
              <hr className="mt-2 pb-0 mb-2" style={{width: "80%", borderTop: "1px solid #F66640",textAlign: "center"}}/>
              </div>

        <div>
        <Row className="justify-content-center">
          {category.writersLinkedinProfile  !== 'undefined' && category.writersLinkedinProfile  !== 'none' && category.writersLinkedinProfile  !== null ? (
            <Col md={2} sm={2} xs={2} style={{ textAlign: "center" }}>
             <a href={category.writersLinkedinProfile} target="_blank"  rel="noreferrer">
            <img
              width="25px"
              height="25px"
              src="/Illustrations/linkedin 2.svg"
              alt=""
            />
          </a>
            </Col>
          ) : null}
          
        {category.writersTwitterProfile  !== 'undefined' && category.writersTwitterProfile  !== 'none'  && category.writersLinkedinProfile  !== null ? (
            <Col  md={2} sm={2} xs={2} style={{ textAlign: "center" }}>
             <a href={category.writersTwitterProfile} target="_blank"  rel="noreferrer">
             <img
              width="25px"
              height="25px"
              src="/Illustrations/twitter 1.svg"
              alt=""
            />
          </a>
            </Col>
          ) : null}

            
          </Row>
        </div>
        </div>
        </Col>
    </Row>
    </div>
  );
}

export default WritersCard;
